@import '~style-sheet-helpers/core.less';
@import '../../app-brand/entities/entity-layer.module.less';
@import (reference) '../../constants/spacing.module.less';

.popover {
  font-size: 14px;
  line-height: 24px;
  display: flex;
  flex-direction: column;
  max-height: 400px;
}

.title-section {
  background-color: @fulfillment-planner--requested-shipping-service-popover--background-color;
  border-bottom: 1px solid var(--grey-300);
  display: flex;
  flex-direction: column;
  padding: @space-8 @space-16;
}

.title-text {
  font-weight: @bold;
  font-size: 16px;
}

.body-section {
  margin: @space-8 @space-16;
  border-bottom: 1px solid var(--grey-300);

  &:last-child {
    border-bottom: none;
  }
}

.shipment-container {
  overflow-y: auto;
}

.body-row {
  display: grid;
  grid-template-columns: 1fr 2fr;
  padding-bottom: @space-8;
}

.label {
  padding-right: @space-12;
}

.target-icon {
  > svg {
    height: 20px;
    width: 20px;
    color: @fulfillment-planner--requested-shipping-service-popover--fill-color;
    margin-top: 3px;
  }
  padding-left: 5px;
  &:hover {
    cursor: pointer;
  }
}

.summary {
  background-color: @fulfillment-planner--requested-shipping-service-popover--background-color;
  padding: @space-8 @space-16;
  border-top: 1px solid var(--grey-300);
}

.total-amount {
  font-weight: 500;
}
